import Vue from 'vue'
import Vuex from 'vuex'
import config from './store-config'
import innerChat from './inner-chat'
import editTenderStore from './editTenderStore'
import notification from './notification'
import dbStore from './dbStore'
import offerAccreditationStore from './offerAccreditationStore'
import indexedDBPlugin from '../plugins/indexedDBPlugin.js'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    config,
    innerChat,
    notification,
    dbStore,
    editTenderStore,
    offerAccreditationStore
  },
  plugins: [indexedDBPlugin]
})

export default store
